export default {
    loginForm: {
        email : '',
        password : ''
    },
    resetPasswordForm: {
        recovery_password : '',
        new_password : '',
        confirm_password : ''
    },
    changePasswordForm: {
        old_password : '',
        new_password : '',
        confirm_password : ''
    },
}